@let _pulseSurvey = pulseSurvey();

<div class="text-center mb-3">
	<h3 class="text-primary text-capitalize">
		{{ _pulseSurvey.testName | translate }}
	</h3>
	<h4>{{ "how_to_interpret_your_score" | translate }}</h4>
</div>

<div class="card">
	@for (score of _pulseSurvey.scoring; track score.startScore) { @let
	isCurrentScore = isUserScore(score.startScore, score.endScore);
	<div class="d-flex align-items-center">
		<div
			class="score me-4 d-flex align-items-center justify-content-center"
			[ngStyle]="{ 'background-color': score.color }"
		>
			<h6 class="mb-0 text-white">
				{{ score.startScore }}
				- {{ score.endScore }}
			</h6>
		</div>
		<div class="d-flex align-items-center">
			@if (isCurrentScore) {
			<img
				alt="Current score"
				src="../../../assets/images/icons/chevron-right.svg"
				width="20"
				class="filter-base-1"
			>
			}
			<h6 class="mb-0" [ngClass]="isCurrentScore ? 'text-primary' : ''">
				{{ score.name | translate }}
			</h6>
		</div>
	</div>
	}
</div>
@let _score = score();
<div class="card">
	<h5>{{ "your_score" | translate }}</h5>
	<p>{{ _score.description | translate }}</p>
	@if (_score.advice | translate) {
	<h5>{{ "recommendations" | translate }}</h5>
	<p>{{ _score.advice | translate }}</p>
	}
</div>

<app-collapse [title]="'understanding' | translate">
	<p [innerHTML]="_pulseSurvey.understandingText | translate"></p>
</app-collapse>

<app-collapse [title]="'disclaimer' | translate">
	<p [innerHTML]="_pulseSurvey.disclaimer | translate"></p>
</app-collapse>

<app-collapse [title]="'credits' | translate">
	<p [innerHTML]="_pulseSurvey.credits | translate"></p>
</app-collapse>
